import _ from 'lodash';
import Sdk from '@/sdk';

export default {
    namespaced: true,
    state: {
        records: [],
        tempPassLevels: [],
        guestPlayTimes: 0,
    },
    getters: {
        passComics(state, getters, rootState) {
            if (!rootState.user) return state.tempPassLevels;
            return _.chain(rootState.user?.passComics)
                .map((value, level) => ({ level: _.parseInt(level, 10), value }))
                .filter(['value', 1])
                .map('level')
                .value();
        },
        showGuestLogin(state, getters, rootState) {
            return !rootState.user && state.guestPlayTimes > 0;
        },
    },
    actions: {
        recordAnswer({ state }, { id, correct }) {
            state.records.push({ id, correct });
        },
        submitAnswer({ state, rootState }, level) {
            if (rootState.user) {
                Sdk.submitComicResult({ level, records: state.records });
            } else {
                if (!_.find(state.records, ['correct', false])) {
                    state.tempPassLevels.push(level);
                }
                state.guestPlayTimes += 1;
            }
            state.records = [];
        },
    },
};
